import { render } from "./WohnungStep8b.vue?vue&type=template&id=b4f978bc&scoped=true"
import script from "./WohnungStep8b.vue?vue&type=script&lang=js"
export * from "./WohnungStep8b.vue?vue&type=script&lang=js"

import "./WohnungStep8b.vue?vue&type=style&index=0&id=b4f978bc&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4f978bc"]])

export default __exports__